import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Form, Row } from 'react-bootstrap'
import { toast } from 'react-toastify';
import axios from 'api/axios';
import moment from 'moment/moment';
import Swal from 'sweetalert2'

import PageHeader from 'components/common/PageHeader';
import DataCard from 'components/mycomponents/DataCard';
import ModalAlert from 'components/mycomponents/ModalAlert';

import Config from 'utils/config';
// import { dateTimeDatabase } from 'utils/FormatDate';

import Data from './Data';
import Detail from './Detail';
// import ChattingForm from './ChattingForm';

import { io } from 'socket.io-client';
// const socket = io('http://192.168.1.109:3012');
const socket = io('https://websocket-chatting.pohonmedia.com/');

const Chatting = () => {
    // Declare State Variable
    const [data, setData] = useState(null);
    const [dataDetail, setDataDetail] = useState(null);
    const [busSelected, setBusSelected] = useState('');
    const [showDetail, setShowDetail] = useState(false);
    const [showChatingForm, setShowChatingForm] = useState(false);
    // const [dataMessage, setDataMessage] = useState([]);
    // const [dataConversation, setDataConversation] = useState({intid: 0, intstatus: 0});
    // const [message, setMessage] = useState('');
    const [keyword, setKeyword] = useState({q:'', reportTime:1, reportMonth: moment().format('M'), reportYear: moment().format('YYYY'), fromDate: moment().format('YYYY-MM-DD'), toDate: moment().format('YYYY-MM-DD')});
    const [keywordShow, setKeywordShow] = useState({q: true, reportTime: true, reportMonth: false, reportYear: false, fromDate: true, toDate: false});
    const [pagination, setPagination] = useState({disabledPrev: true, disabledNext: false, pageTotal: 0, currentPage: 1, limit: 10, numberStart: 0});
    const [loadingData, setLoadingData] = useState(false);
    const [loadingDataDetail, setLoadingDataDetail] = useState(false);
    const [showAlert, setShowAlert] = useState({show: false, message: '', type: '', confirmButton: false});
    // const [scrollToBottom, setScrollToBottom] = useState(false);

    // Declare Constant Variable
    const navigate = useNavigate();
    const DATA_URL = '/conversation';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    // const USERID = ACCESS_USER ? ACCESS_USER.user_id : '0';
    const HEADER_AUTHORIZATION = {
        headers: {
          'Authorization': `Bearer ${TOKEN_APP}`
        }
    };
    const CHAT_TOKEN = 'vrf74HWbfDNMWsRaFBXPbDjmIqsIj7aDSwEIVfJqZw2osT1gDQ96TPJORvczpu3G';

    // function get data
    const getData = async (page = 1, limit = 10) => {
        setLoadingData(true);
        let fromDate = keyword.fromDate;
        let toDate = keyword.toDate;
        if (keyword.reportTime === '3') {
            fromDate = moment(`${keyword.reportYear}-${keyword.reportMonth}-01`).format('YYYY-MM-DD');
            toDate = moment(`${keyword.reportYear}-${keyword.reportMonth}-01`).endOf('month').format('YYYY-MM-DD');
        }
        try {
            const response = await axios.get(`${DATA_URL}?q=${keyword.q}&from=${fromDate}&to=${toDate}&page=${page}&limit=${limit}`, HEADER_AUTHORIZATION);
            const responseResult = response?.data;
            const responseData = responseResult?.data;
            const responseDataLength = responseResult?.length;
            const responseDataPageTotal = responseResult?.page_total;

            if (responseDataLength > 0) {
                setData(responseData);
                setPagination(prevState => {
                    return {...prevState, pageTotal: responseDataPageTotal, limit: limit, currentPage: page, numberStart: limit * (page - 1)}
                })
            } else {
                setData(null);
            }
            if (page >= responseDataPageTotal) {
                setPagination(prevState => {
                    return {...prevState, disabledNext: true}
                })
            } else {
                setPagination(prevState => {
                    return {...prevState, disabledNext: false}
                })
            }
            if (page === 1) {
                setPagination(prevState => {
                    return {...prevState, disabledPrev: true}
                })
            }
            setLoadingData(false);
            
        } catch (err) {
            setLoadingData(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    // Get Data On Load
    useEffect(() => {
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const fromDateParam = urlParams.get('from');
        const toDateParam = urlParams.get('to');
        const reportTimeParam = urlParams.get('rt');
        const reportMonthParam = urlParams.get('m');
        const reportYearParam = urlParams.get('y');

        const keywordValue = keywordParam ? keywordParam : '';
        const fromDateValue = fromDateParam ? fromDateParam : moment().format('YYYY-MM-DD');
        const toDateValue = toDateParam ? toDateParam : moment().format('YYYY-MM-DD');
        const reportTimeValue = reportTimeParam ? reportTimeParam : 1;
        const reportMonthValue = reportMonthParam ? reportMonthParam : moment().format('M');
        const reportYearValue = reportYearParam ? reportYearParam : moment().format('YYYY');

        if (reportTimeValue === '1') {
            setKeywordShow(prevState => {
                return {...prevState, reportMonth: false, reportYear: false, fromDate: true, toDate: false}
            })
        }
        if (reportTimeValue === '2') {
            setKeywordShow(prevState => {
                return {...prevState, reportMonth: false, reportYear: false, fromDate: true, toDate: true}
            })
        }
        if (reportTimeValue === '3') {
            setKeywordShow(prevState => {
                return {...prevState, reportMonth: true, reportYear: true, fromDate: false, toDate: false}
            })
        }

        let keywordTemp = keyword;
        keywordTemp.q = keywordValue
        keywordTemp.fromDate = fromDateValue
        keywordTemp.toDate = toDateValue
        keywordTemp.toDate = toDateValue
        keywordTemp.reportTime = reportTimeValue
        keywordTemp.reportMonth = reportMonthValue
        keywordTemp.reportYear = reportYearValue
        setKeyword(keywordTemp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    // Toggle Form to open and close modal detail
    const handleToggleDetail = () => {
        setShowDetail(!showDetail);
    }

    const handleDetail = async (intid) => {
        const selectData = data ? data.find(data => parseFloat(data.intid) === parseFloat(intid)) : null;
        const busName = selectData ? selectData.vcnama : '';
        setBusSelected(busName);

        setLoadingDataDetail(true);
        try {
            const response = await axios.get(`${DATA_URL}/detail/${intid}/${keyword.fromDate}`, HEADER_AUTHORIZATION);
            const responseData = response?.data;
            const responseDataResult = responseData?.data;
            
            setDataDetail(responseDataResult)
            setShowDetail(true);
            setLoadingDataDetail(false);
        } catch (err) {
            setLoadingDataDetail(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleToggleChatting = () => {
        setShowChatingForm(!showChatingForm);
    }

    const handleConfirm = (type, intid = 0, status = 0, token = '') => {
        let msg = 'Konfirmasi';
        if (type === 'chat') {
            msg = 'Apakah anda akan membalas pesan ini ?';
            if (parseFloat(status) === 1 || parseFloat(status) === 2) {
                navigate('/operasional/complaint-message/' + intid + '/' + token);
                // handleChatting(intid);
                return;
            }
        }
        if (type === 'endChat') {
            msg = 'Apakah anda akan mengkahiri pesan ini ?';
        }
        Swal.fire({
            title: "Konfirmasi",
            text: msg,
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
          }).then((result) => {
            if (result.isConfirmed) {
              if (type === 'chat') {
                navigate('/operasional/complaint-message/' + intid + '/' + token);
              }
              if (type === 'endChat') {
                handleEndChatting(intid)
              }
            }
          });
        return;
    }

    // const handleChatting = async (intid) => {
    //     setLoadingDataDetail(true);
    //     try {
    //         const response = await axios.get(`${DATA_URL}/message?conversationId=${intid}&userId=${USERID}`, HEADER_AUTHORIZATION);
    //         const responseData = response?.data;
    //         const responseDataResult = responseData?.data;
            
    //         setDataConversation(responseDataResult);
    //         setDataMessage(responseDataResult.conversation_message);
    //         setLoadingDataDetail(false);
    //         setShowChatingForm(true);
    //         setScrollToBottom(true);
            
    //         // setDataDetail(responseDataResult)
    //         // setShowDetail(true);
    //     } catch (err) {
    //         setLoadingDataDetail(false);
    //         if (err.response) {
    //             if (err?.response.status === 401) {
    //                 toast.error(err?.response.data.message);
    //                 localStorage.removeItem('accessUser');
    //                 navigate('/login');
    //             } else {
    //                 const response = err.response.data;
    //                 setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
    //             }
    //         } else {
    //             setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
    //         }
    //     }
    // }

    const handleEndChatting = async (intid) => {
        setLoadingDataDetail(true);
        try {
            await axios.get(`${DATA_URL}/endChat/${intid}`, HEADER_AUTHORIZATION);
            // const responseData = response?.data;
            // const responseDataResult = responseData?.data;
            setLoadingDataDetail(false);
            handleToggleChatting();
            Swal.fire({
                title: "Berhasil",
                text: "Pesan sudah diakhiri",
                icon: "success",
                showCancelButton: false
            });
        } catch (err) {
            setLoadingDataDetail(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleChangeForm = (event, state = '') => {
        const {value, name} = event.target;
        if (state === 'keyword') {
            setKeyword(prevState => {
                return {...prevState, [name]: value};
            })
            if (name === 'reportTime') {
                if (value === '1') {
                    setKeywordShow(prevState => {
                        return {...prevState, reportMonth: false, reportYear: false, fromDate: true, toDate: false}
                    })
                }
                if (value === '2') {
                    setKeywordShow(prevState => {
                        return {...prevState, reportMonth: false, reportYear: false, fromDate: true, toDate: true}
                    })
                }
                if (value === '3') {
                    setKeywordShow(prevState => {
                        return {...prevState, reportMonth: true, reportYear: true, fromDate: false, toDate: false}
                    })
                }
            }
        } else if (state === 'message') {
            // setMessage(value);
        } else if (name === 'limit') {
            setPagination(prevState => {
                return {...prevState, limit: value}
            })
            const page = 1;
            const keywordSearch = keyword;
            const pathUrl = window.location.pathname;
            const urlNavigate = `${pathUrl}?q=${keywordSearch}&page=${page}`
            navigate(urlNavigate)
            getData(1, value)
        }
    }

    const handleChangeDate = (value, name) => {
        setKeyword(prevState => {
            return {...prevState, [name]: moment(value).format('YYYY-MM-DD')};
        })
        if (name === 'fromDate') {
            const fromDateTemp = moment(value).format('YYYY-MM-DD');
            const toDateTemp = moment(keyword.toDate).format('YYYY-MM-DD');
            if (fromDateTemp > toDateTemp) {
                setKeyword(prevState => {
                    return {...prevState, toDate: moment(value).format('YYYY-MM-DD')};
                })
            }
        }
        if (name === 'toDate') {
            const fromDateTemp = moment(keyword.fromDate).format('YYYY-MM-DD');
            const toDateTemp = moment(value).format('YYYY-MM-DD');
            if (fromDateTemp > toDateTemp) {
                setKeyword(prevState => {
                    return {...prevState, fromDate: moment(value).format('YYYY-MM-DD')};
                })
            }   
        }
    }

    const handleSearch = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const page = 1;
        const keywordSearch = keyword.q;
        const keywordFromDate = moment(keyword.fromDate).format('YYYY-MM-DD');
        const keywordToDate = moment(keyword.toDate).format('YYYY-MM-DD');
        const keywordReportTime = keyword.reportTime;
        const keywordReportMonth = keyword.reportMonth;
        const keywordReportYear = keyword.reportYear;
        const pathUrl = window.location.pathname;
        let urlNavigate = `${pathUrl}?q=${keywordSearch}&rt=${keywordReportTime}&from=${keywordFromDate}&to=${keywordToDate}&page=${page}`
        if (keywordReportTime === '3') {
            urlNavigate = `${pathUrl}?q=${keywordSearch}&rt=${keywordReportTime}&from=${keywordFromDate}&to=${keywordToDate}&m=${keywordReportMonth}&y=${keywordReportYear}&page=${page}`
        }
        navigate(urlNavigate)
        getData(page)
    }

    const handleClickPagination = (type) => {
        let count = 0;
        if (type === 'prev') {
            count = -1
        }
        if (type === 'next') {
            count = 1
        }

        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const pageParam = urlParams.get('page');
        const fromDateParam = urlParams.get('from');
        const toDateParam = urlParams.get('to');
        const reportTimeParam = urlParams.get('rt');
        const reportMonthParam = urlParams.get('m');
        const reportYearParam = urlParams.get('y');

        const page = pageParam ? parseFloat(pageParam) + count : 2;
        const keywordSearch = keywordParam ? keywordParam : keyword.q;
        const fromDateValue = fromDateParam ? fromDateParam : keyword.fromDate;
        const toDateValue = toDateParam ? toDateParam : keyword.toDate;
        const reportTimeValue = reportTimeParam ? reportTimeParam : keyword.reportTime;
        const reportMonthValue = reportMonthParam ? reportMonthParam : keyword.reportMonth;
        const reportYearValue = reportYearParam ? reportYearParam : keyword.reportYear;
        const pathUrl = window.location.pathname;

        if (page > 1) {
            setPagination(prevState => {
                return {...prevState, disabledPrev: false}
            })
        } else {
            setPagination(prevState => {
                return {...prevState, disabledPrev: true}
            })
        }

        let urlNavigate = `${pathUrl}?q=${keywordSearch}&rt=${reportTimeValue}&from=${fromDateValue}&to=${toDateValue}&page=${page}`;
        if (reportTimeValue === '3') {
            urlNavigate = `${pathUrl}?q=${keywordSearch}&rt=${reportTimeValue}&from=${fromDateValue}&to=${toDateValue}&m=${reportMonthValue}&y=${reportYearValue}&page=${page}`
        }
        navigate(urlNavigate)
        getData(page, pagination.limit)
    }

    const handleConfirmAlert = () => {
        setShowAlert(prevState => { return {...prevState, show: false}});
    }

    const handleClickExport = () => {
        let fromDate = keyword.fromDate;
        let toDate = keyword.toDate;
        if (keyword.reportTime === '3') {
            fromDate = moment(`${keyword.reportYear}-${keyword.reportMonth}-01`).format('YYYY-MM-DD');
            toDate = moment(`${keyword.reportYear}-${keyword.reportMonth}-01`).endOf('month').format('YYYY-MM-DD');
        }
        window.open(`${Config.baseUrlApi}/report/bus/export?q=${keyword.q}&from=${fromDate}&to=${toDate}`, '_blank');
        // window.open(Config.baseUrlApi + '/report/bus/export/' + keyword.fromDate, '_blank')
    }

    // const sendMessage = async () => {
    //     let dataMessageTemp = {
    //         intid: 0,
    //         intconverstion_id: dataConversation ? dataConversation.intid : 0,
    //         intsender_id: USERID,
    //         vcmessage: message,
    //         dtadd: dateTimeDatabase(),
    //         intstatus:0,
    //         intis_admin:1
    //     };
    //     console.log(dataMessageTemp);

    //     try {
    //         const response = await axios.post(`${DATA_URL}/message`, dataMessageTemp, HEADER_AUTHORIZATION);
    //         const responseData = response?.data;
    //         const responseDataResult = responseData?.data;
    //         console.log(responseDataResult);
            
    //         // setDataDetail(responseDataResult)
    //         // setShowDetail(true);
    //         const emitData = {
    //             'id': dataConversation ? dataConversation.token_member : '0',
    //             'message':JSON.stringify(dataMessageTemp)
    //         }
    //         socket.emit('message', emitData);
    //     } catch (err) {
    //         setLoadingDataDetail(false);
    //         if (err.response) {
    //             if (err?.response.status === 401) {
    //                 toast.error(err?.response.data.message);
    //                 localStorage.removeItem('accessUser');
    //                 navigate('/login');
    //             } else {
    //                 const response = err.response.data;
    //                 setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
    //             }
    //         } else {
    //             setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
    //         }
    //     }
        
    //     setMessage('');
    //     setDataMessage(prevState => [...prevState, dataMessageTemp]);
    //     setScrollToBottom(true);
    // }

    const handleSocketMessage = (msg) => {
        // setDataMessage(prevState => [...prevState, JSON.parse(msg)]);
        // setScrollToBottom(true);
    }

    useEffect(() => {
        socket.on(CHAT_TOKEN, (msg) => {
            handleSocketMessage(msg);
        });
    },[])

    return (
        <>
            {/* Page Header */}
            <PageHeader
                title="Pesan Pengaduan"
                description=""
                className="mb-3"
            >
            </PageHeader>

            {/* Data */}
            <DataCard>
                <DataCard.HeaderReport 
                    title={''} 
                    keywordShow={keywordShow}
                    keyword={keyword} 
                    handleChangeKeyword={handleChangeForm} 
                    handleSearch={handleSearch} 
                    handleChangeDate={handleChangeDate} 
                    exportExcel 
                    handleClickExport={handleClickExport} />
                <DataCard.Body>
                    <Data 
                        dataMain={data}
                        actionDetail={handleDetail} 
                        actionChatting={handleConfirm}
                        numberStart={pagination.numberStart} 
                        isLoading = {loadingData}
                    />
                    <Row>
                        <Col sm={2}>
                            <Form.Select
                                name="limit"
                                value={pagination.limit}
                                onChange={handleChangeForm}
                            >
                                <option value={10}>10 Baris</option>
                                <option value={20}>20 Baris</option>
                                <option value={30}>30 Baris</option>
                            </Form.Select>
                        </Col>
                        <Col sm={10}>
                            <div className="float-end">
                                <Button variant="primary" size="sm" disabled={pagination.disabledPrev} onClick={() => handleClickPagination('prev')} className="me-2">Sebelumnya</Button>
                                <Button variant="primary" size="sm" disabled={pagination.disabledNext} onClick={() => handleClickPagination('next')}>Selanjutnya</Button>
                            </div>
                        </Col>
                    </Row>
                </DataCard.Body>
            </DataCard>

            {/* Detail Data */}
            <Detail 
                show={showDetail}
                handleClose={handleToggleDetail}
                data={dataDetail}
                busName={busSelected}
                date={keyword.fromDate}
                loadingDataDetail={loadingDataDetail}
            />

            {/* Chatting Form */}
            {/* <ChattingForm
                show={showChatingForm}
                handleClose={handleToggleChatting}
                scrollToBottom={scrollToBottom}
                setScrollToBottom={setScrollToBottom}
                dataMessage={dataMessage}
                // dataConversation={dataConversation}
                message={message}
                handleChange={handleChangeForm}
                // sendMessage={sendMessage}
                handleConfirm={handleConfirm}
            /> */}

            <ModalAlert 
                type={showAlert.type}
                show={showAlert.show}
                message={showAlert.message}
                onHide={() => setShowAlert(prevState => { return {...prevState, show: false} })}
                onConfirm={handleConfirmAlert}
                confirmButton={showAlert.confirmButton}
            />
        </>
    )
}

Chatting.propTypes = {}

export default Chatting;